export const regions = {
  types: [
    {
      id: 'places',
      name: 'Places',
      nameSingular: 'Place',
    },
    {
      id: 'counties',
      name: 'Counties',
      nameSingular: 'County',
    },
  ]
}
